import React, { useState, useRef, useEffect } from "react";
import { Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../CommonCSS/SocietyCSS.css";
import { toast } from "react-toastify";
import EmployeeKpiModal from "./Emp_KPI_Modal";

const MDMonthlyReview = () => {

  const inputRefs = useRef([]);

  const today = new Date();

  const defaultMonth =
    today.getMonth() === 0 ? 12 : today.getMonth(); // getMonth() is 0-based

  const defaultYear =
    today.getMonth() === 0
      ? today.getFullYear() - 1
      : today.getFullYear();

  const [filters, setFilters] = useState({
    month: defaultMonth.toString(),
    year: defaultYear.toString(),
    category: "0"
  });

  const [rows, setRows] = useState([]);
  const [errors, setErrors] = useState({});
  const [isEditable, setIsEditable] = useState(false);

  const [genMasters, setGenMasters] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  useEffect(() => {

    loadGeneralMasters();

  }, []);

  const loadGeneralMasters = async () => {

    try {

      const response = await axios.get(`${BASE_URL}/api/ddl_Gen_Mst_Type`, 
                        { params: { type: 'CATG' } });

      if (response.data && response.data.length > 0) {
        setGenMasters(response.data);
      }

    } catch (err) {

      console.error("Error loading Team Members", err);

    }

  };

  // 🔹 Load Data
  const handleProceed = async () => {

    if (!filters.month) {
      toast.error("Please select Month and Year");
      return;
    }

    if (!filters.year) {
      toast.error("Please select Month and Year");
      return;
    }

    try {

      const res = await axios.get(`${BASE_URL}/api/get_Emp_KPI_MD_Review`, {
        params: filters
      });

      if (res.data && res.data.length > 0) {
        setRows(res.data);
      } else {
        toast.error("KPI not processed for the entered Period/Category.");
      }

      setIsEditable(true);

      setTimeout(() => {
        inputRefs.current[0]?.[0]?.focus();
      }, 100);

    } catch (err) {
      console.error(err);
      toast.error("Error loading data");
    }

  };

  // 🔹 Navigation (Excel style)
  const handleKeyNavigation = (e, rowIndex, colIndex) => {

    let newRow = rowIndex;
    let newCol = colIndex;

    switch (e.key) {
      case "ArrowUp":
        newRow--;
        break;
      case "ArrowDown":
        newRow++;
        break;
      case "ArrowLeft":
        newCol--;
        break;
      case "ArrowRight":
        newCol++;
        break;
      case "Enter":
        newRow++;
        break;
      default:
        return;
    }

    e.preventDefault();

    if (
      inputRefs.current[newRow] &&
      inputRefs.current[newRow][newCol]
    ) {
      inputRefs.current[newRow][newCol].focus();
    }
  };

  // 🔹 Handle Input Change
  const handleChange = (index, field, value) => {

    const updated = [...rows];

    if (field === "md_kpi_perc") {
      if (value === "" || (Number(value) >= 0 && Number(value) <= 100)) {
        updated[index][field] = value;
      }
    } else {
      updated[index][field] = value;
    }

    setRows(updated);
  };

  // 🔹 Save
  const handleSave = async () => {

    let rowErrors = {};
    let errorRowIndex = null;

    for (let i = 0; i < rows.length; i++) {

      if (!rows[i].md_kpi_perc) {
        rowErrors[i] = { md_kpi_perc: true };
        errorRowIndex = i;
        break;
      }
    }

    if (errorRowIndex !== null) {
      setErrors({ rowErrors });
      toast.error(`MD Rating missing at row ${errorRowIndex + 1}`);
      inputRefs.current[errorRowIndex]?.[0]?.focus();
      return;
    }

    const isConfirmed = window.confirm("Save KPI data ?");
    if (!isConfirmed) return;

    try {

      await axios.post(`${BASE_URL}/api/upd_MD_Review_Kpi`, {
        header: filters,
        details: rows
      });

      toast.success("Saved successfully");
      setIsEditable(false);

    } catch (err) {
      console.error(err);
      toast.error("Error saving data");
    }
  };

  // const getColorClass = (value) => {
  //   if (value === null || value === undefined) return "";

  //   const val = Number(value);

  //   // if (val <= 60) return "kpi-red";
  //   // if (val <= 75) return "kpi-yellow";
  //   // return "kpi-green";

  //   if (val > 80) return "gold";
  //   return "";

  // };
  
  const showStar = (row) => {

    const finalPerc = Number(
      row.md_kpi_perc ?? row.sup_kpi_perc ?? 0
    );

    return finalPerc > 80;
  };

  return (

    <Container fluid className="p-3">

      {/* HEADER */}
      <Card className="p-3 mb-3">

        <Row>

          <Col md={2}>
            <InputGroup>
              <InputGroup.Text>Month</InputGroup.Text>
              <select
                className="form-select"
                value={filters.month}
                onChange={(e) => setFilters({ ...filters, month: e.target.value })}
              >
                <option value="">-- Month --</option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
                
              </select>
            </InputGroup>
          </Col>

          <Col md={2}>
            <InputGroup>
              <InputGroup.Text>Year</InputGroup.Text>
              <input type="number" value={filters.year}
                onChange={(e) => setFilters({ ...filters, year: e.target.value })}
                className="form-control" style={{ textAlign: "right" }} />
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text>Category</InputGroup.Text>
              <select
                className="form-select"
                onChange={(e) =>  setFilters({ ...filters, category: e.target.value })}
              >
                <option value="">--- Select Staff Category ---</option>
                <option value="0">All Staff</option>
                {genMasters.map(gm => (
                      <option key={gm.gen_id} value={gm.gen_id}>{gm.gen_desc}</option>
                ))}

              </select>
            </InputGroup>
          </Col>

          <Col md={4}>
            <Button variant="primary" 
            onClick={handleProceed} style={{ width: "130px" }}>
              Proceed
            </Button>
            &nbsp;&nbsp;
            <Button variant="secondary" 
            onClick={handleProceed} style={{ width: "130px" }}>
              Clear
            </Button>
            &nbsp;&nbsp;
            <Button variant="success" onClick={handleSave} 
            disabled={!isEditable} style={{ width: "130px" }}> 
              Save
            </Button>

          </Col>

          {/* <Col md={2}>


          </Col> */}

        </Row>

      </Card>

      {/* TABLE */}
      <Card className="p-3">

        <div style={{ minHeight: '220px' }} className="table-wrapper">

          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">

            <thead>
              <tr>
                <th style={{ width: "4%", textAlign: "center" }}>#</th>
                <th style={{ width: "32%", textAlign: "left" }}>Employee</th>
                {/* <th style={{ width: "10%", textAlign: "right" }}>Emp KPI %</th> */}
                <th style={{ width: "8%", textAlign: "right" }}>Sup KPI %</th>
                <th style={{ width: "8%", textAlign: "right" }}>HM KPI %</th>
                <th style={{ width: "15%", textAlign: "left" }}>HM Remarks</th>
                <th style={{ width: "10%", textAlign: "right" }}>MD %</th>
                <th style={{ width: "24%", textAlign: "left" }}>MD Comments</th>
              </tr>
            </thead>

            <tbody>

              {rows.map((row, index) => (

                <tr key={index}>
{/* className={getColorClass(row.sup_kpi_perc)} 
className={showStar(row) && "gold"}*/}
                  <td style={{ textAlign: "center" }} >{index + 1}</td>
                  <td style={{ textAlign: "left" }} >
                    {showStar(row) && <span className="kpi-star">⭐⭐🏆</span>}
                    <span
                      style={{
                        color: "#0d6efd",
                        cursor: "pointer",
                        textDecoration: "underline"
                      }}
                      onClick={() => {
                        setSelectedEmployee(row);
                        setShowModal(true);
                      }}
                    >
                      {row.emp_name}
                    </span>
                    </td>
                  {/* <td style={{ textAlign: "right" }} >{row.emp_kpi_perc}</td> */}
                  <td style={{ textAlign: "right" }} >{row.sup_kpi_perc}</td>
                  <td style={{ textAlign: "right" }} >{row.hm_kpi_perc}</td>
                  <td style={{ textAlign: "left" }} >{row.hm_rem}</td>

                  {/* MD % */}
                  <td>
                    <input
                      type="number"
                      style={{ textAlign: "right" }}
                      className={`form-control ${errors?.rowErrors?.[index]?.md_kpi_perc ? "is-invalid" : ""}`}
                      value={row.md_kpi_perc || ""}
                      disabled={!isEditable}
                      onChange={(e) => handleChange(index, "md_kpi_perc", e.target.value)}
                      ref={(el) => {
                        if (!inputRefs.current[index]) inputRefs.current[index] = [];
                        inputRefs.current[index][0] = el;
                      }}
                      onKeyDown={(e) => handleKeyNavigation(e, index, 0)}
                    />
                  </td>

                  {/* MD Comment */}
                  <td>
                    <textarea
                      className="form-control"
                      value={row.md_rem || ""}
                      disabled={!isEditable}
                      rows={1}
                      onChange={(e) => handleChange(index, "md_rem", e.target.value)}
                      ref={(el) => {
                        if (!inputRefs.current[index]) inputRefs.current[index] = [];
                        inputRefs.current[index][1] = el;
                      }}
                      onKeyDown={(e) => handleKeyNavigation(e, index, 1)}
                    />
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </Card>

      <EmployeeKpiModal
        show={showModal}
        onHide={() => setShowModal(false)}
        employee={selectedEmployee}
        filters={filters}
      />

    </Container>
  );
};

export default MDMonthlyReview;
